const U=v=>String(v||'MISSING').toUpperCase();

export function deriveStockOpportunityEvidence(bundle={}){
 const tenX=U(bundle?.tenXResearch?.state);
 const fox=U(bundle?.foxEvidence?.state);
 const rocket=U(bundle?.rocketEvidence?.state);
 const sheep=U(bundle?.sheepEvidence?.state);
 const mole=U(bundle?.moleEvidence?.state);
 const grass=U(bundle?.grasshopperEvidence?.state);

 const supports=[];
 const risks=[];
 const observed=[];

 const observe=(name,state)=>{if(!['MISSING','REVIEW'].includes(state))observed.push(name)};
 observe('10X',tenX);observe('FOX',fox);observe('ROCKET',rocket);observe('SHEEP',sheep);observe('MOLE',mole);observe('GRASSHOPPER',grass);

 if(['HIGH_10X_RESEARCH_PRIORITY','WATCH_10X_RESEARCH_PRIORITY'].includes(tenX))supports.push('10X_RESEARCH_PRIORITY');
 if(['STRONGLY_UNDERFOLLOWED','UNDERFOLLOWED'].includes(fox))supports.push('UNDERFOLLOWED');
 if(['POSITIVE_REPRICING','POSITIVE_REVISION_DIVERGENCE'].includes(rocket))supports.push('POSITIVE_REPRICING');
 if(['LOWER_ELASTICITY','DEEP_LIQUIDITY_PROXY'].includes(grass))supports.push('LIQUIDITY_SUPPORT');

 if(['MULTI_CROWDING','SHORT_CROWDED','HOLDER_CONCENTRATED','ELEVATED_CROWDING'].includes(sheep))risks.push('CROWDING_RISK');
 if(['NEGATIVE_REPRICING','NEGATIVE_REVISION_DIVERGENCE'].includes(rocket))risks.push('NEGATIVE_REPRICING');
 if(['RISK_FLAG','MULTIPLE_RISK_FLAGS'].includes(mole))risks.push('HIDDEN_RISK');
 if(['HIGH_ELASTICITY','ELEVATED_ELASTICITY','ELASTICITY_RISK_PROXY','TIGHT_LIQUIDITY_PROXY'].includes(grass))risks.push('ELASTICITY_RISK');

 let state='REVIEW';
 if(observed.length>=3){
  if(supports.length>=2&&risks.length===0)state='OPPORTUNITY_EVIDENCE_STACKED';
  else if(supports.length>=2&&risks.length>0)state='OPPORTUNITY_WITH_RISK';
  else if(risks.length>=2&&supports.length===0)state='RISK_HEAVY';
  else state='MIXED_STOCK_EVIDENCE';
 }

 return{
  status:state==='REVIEW'?'REVIEW':'EVIDENCE',
  state,
  observedLayers:observed,
  observedCount:observed.length,
  supports,
  supportCount:supports.length,
  risks,
  riskCount:risks.length,
  inputs:{tenX,fox,rocket,sheep,mole,grasshopper:grass},
  note:'Stock Opportunity summarizes separate stock-level evidence layers without collapsing them into a universal score. It excludes Dog business quality and Horse/Pig macro context, and it never creates BUY/SELL, entry permission or capital permission.'
 };
}
